import { ISaveloanInfoPayload } from '@components/SoftPullAcknowledgementPage/SoftPullAcknowledgementPage';
import { ApiResources, createErrorResponse, getRequestHeaders, getUrl, Methods, processResponse } from './utils';

interface ErrorResponse {
  error: {
    status?: number | string;
    message: string;
  };
}

export interface ISoftpullRequestPayload {
  contactId: string;
  leadId: string;
}

export interface ICurrentLoanInfoData {
  remainingLoanBalance: number;
  currentMonthlyPayment: number;
  remainingLoanTerm: number;
  currentInterestRate: number;
  creditScoreRange: string;
  state: string;
  zipCode: string;
}

export interface IAccurateEstimatedOfferResponse {
  dealId: null | string;
  rate: number;
  monthlyPaymentAmount: number;
  term: number;
  offerType: string;
}

interface IFicoDetails {
  name: string;
  score: string;
  type: string;
}

export interface ILoanDetails {
  currentBalance: number;
  lender: string;
  openDate: string;
  payment: number;
  remainingTerm: number;
}

export interface IGetCreditSummaryResponse {
  ficoDetails: IFicoDetails[];
  loanDetails: ILoanDetails[];
}

export const saveLoanInformation = async (
  balanceAmountPayload: ISaveloanInfoPayload
): Promise<ISaveloanInfoPayload | ErrorResponse> => {
  try {
    const saveLoanInformationEndpoint = `${getUrl(ApiResources.saveLoanInformation)}`;

    const saveLoanInformationRequest = {
      method: Methods.post,
      headers: await getRequestHeaders(),
      body: JSON.stringify(balanceAmountPayload),
    };

    const saveLoanInformationResponse = await fetch(saveLoanInformationEndpoint, saveLoanInformationRequest);
    return processResponse(saveLoanInformationResponse);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};

export const getCreditSummary = async (
  softpullRequestPayload: ISoftpullRequestPayload
): Promise<IGetCreditSummaryResponse | ErrorResponse> => {
  try {
    const creditSummaryEndpoint = `${getUrl(
      ApiResources.getCreditSummary
    )}${softpullRequestPayload?.contactId}/credit-summary/?leadId=${softpullRequestPayload?.leadId}`;

    const creditSummaryRequest = {
      method: Methods.get,
      headers: await getRequestHeaders(),
    };

    const creditResponse = await fetch(creditSummaryEndpoint, creditSummaryRequest);
    return processResponse(creditResponse);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};

export const getAccurateEstimatedOffer = async (
  softpullRequestPayload: ISoftpullRequestPayload
): Promise<{ offers: IAccurateEstimatedOfferResponse[]; usedDefaultScore: boolean } | ErrorResponse> => {
  try {
    const calculatorOffersEndpoint = `${getUrl(ApiResources.getLenderOffers)}`;
    const calculatorOffersRequest = {
      method: Methods.post,
      headers: await getRequestHeaders(),
      body: JSON.stringify(softpullRequestPayload),
    };

    const offersResponse = await fetch(calculatorOffersEndpoint, calculatorOffersRequest);

    return processResponse(offersResponse);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};
